export const attachmentsTableColumns = [
  {
    field: 'descriptionField',
    headerName: 'TrainerAreaAttachmentTable.description',
    headerAlign: 'left',
    width: 300,
    editable: false,
    valueGetter: (params) => params?.row?.displayName
  },
  {
    field: 'options',
    headerName: 'TrainerAreaAttachmentTable.options',
    headerAlign: 'left',
    width: 150,
    editable: false,
    filterable: false,
    sortable: false
  }
];
